import {
    REQUEST_ITEM,
    RECEIVE_ITEM,
    UPDATE_ITEM,
    ERROR_ITEM, RELOAD_ITEM
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import _get from "lodash/get"
import _set from "lodash/set"
import {loadDataRefresh} from "../../constants/constants"
import _merge from "../../helpers/_merge"
import _isObject from "lodash/isObject"
import _cloneDeep from "lodash/cloneDeep"
import _isArray from "lodash/isArray"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_ITEM:
            const newData = {
                ...state,
                isFetching: true,
                shouldReload: false,
                key: action.payload,
                message: '',
                errors: {}
            }
            if(action.subitem){
                newData.isFetching = false
                const s = state.data[action.subitem]
                newData.data[action.subitem] = {
                    ...s,
                    isFetching: true,
                }
            }
            return newData
        case RECEIVE_ITEM:
            return {
                ...state,
                isFetching: false,
                shouldReload: false,
                data: action.merge ? _merge(state.data, action.payload, action.path) : action.payload,
                message: action.message,
            }
        case RELOAD_ITEM:
            return {
                ...state,
                shouldReload: true,
            }
        case UPDATE_ITEM:
            const data = state.data
            const d = _get(data, action.updateType, {})
            let p = action.payload
            if(action.id){
                if(d.data.results){
                    const index = d.data.results.findIndex(item => item.id == action.id)
                    if(index > -1){
                        if(action.delete){
                            d.data.results.splice(index, 1)
                        }else{
                            d.data.results[index] = {...d.data.results[index], ...p}
                        }
                    }else{
                        if(_isArray(p)){
                            p.map(pp => {
                                d.data.results.unshift(pp)
                            })
                        }else{
                            d.data.results.unshift(p)
                        }
                    }
                    p = {...d.data}
                }
            }
            if(typeof action.payload.u__parent != "undefined"){
                const path = action.updateType
                const parentPath = path.substring(0, path.lastIndexOf('.'))
                _set(data, parentPath, {..._get(data, parentPath, {}), ...action.payload.u__parent})
            }
            _set(data, action.updateType, {...initialFetchState, ...d, data: p, isFetching: false, validUntil: loadDataRefresh.default + Date.now()})
            return {
                ...state,
                data,
                shouldReload: false,
                message: action.message,
            }
        case ERROR_ITEM:
            const newData_ = {
                ...state,
                isFetching: false,
                shouldReload: false,
                errors: action.errors,
                message: '',
            }
            if(_isObject(action.errors) && action.errors.isGET){
                newData_.data = {}
            }
            if(action.subitem){
                newData_.isFetching = false
                const s = _cloneDeep(_get(state.data, action.subitem, {}))
                newData_.data[action.subitem] = {
                    ...s,
                    isFetching: false,
                    errors: action.errors,
                    message: '',
                }
            }
            return newData_
        default:
            return state
    }
}